import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "@msuite/ui/utils";
import { Can } from "@/components/citadel/can";
import { AddVendorArticleModal } from "@/modals/stock/add-vendor-article-modal";

/** Props Interface */
interface VendorArticlesMenuProps {
	articleId: string;
}

export function VendorArticlesMenu({ articleId }: VendorArticlesMenuProps) {
	/** Hooks */
	const { refetch } = useDataTableContext();
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={disclosure.onOpen}
				>
					{t("stock.add_vendor_article")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<AddVendorArticleModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					articleId={articleId}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
